var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgTrash = function SvgTrash(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.384 5.812a2.286 2.286 0 0 1 3.902 1.617H9.715c0-.607.24-1.188.669-1.617ZM8.572 7.43a3.429 3.429 0 1 1 6.857 0h3.428a.571.571 0 0 1 0 1.143h-1.143v9.714A1.714 1.714 0 0 1 16 20H8a1.714 1.714 0 0 1-1.714-1.714V8.572H5.143a.571.571 0 0 1 0-1.143h3.429ZM7.429 8.572h9.143v9.714a.571.571 0 0 1-.572.571H8a.571.571 0 0 1-.571-.571V8.572Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.286 9.714c.315 0 .571.256.571.572v6.285a.571.571 0 1 1-1.143 0v-6.285c0-.316.256-.572.572-.572Zm3.428 0c.316 0 .572.256.572.572v6.285a.572.572 0 0 1-1.143 0v-6.285c0-.316.256-.572.571-.572Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 4h16v16H4z"
  })))));
};
export { SvgTrash as ReactComponent };
export default __webpack_public_path__ + "static/media/trash.fde968f987565996168443a1b99a7370.svg";